import { BrowserRouter } from 'react-router-dom';
import Page from './pages/Page';
import HireMeCursor from './components/HireMeCursor';
import './styles/index.css';
import './styles/App.css';

function App() {
  return (
    <BrowserRouter>
      <div className="app-wrapper">
        <HireMeCursor />
        <Page />
      </div>
    </BrowserRouter>
  );
}

export default App;
